import { render } from "./ProjectsIcon.vue?vue&type=template&id=3d97ebc2&scoped=true"
const script = {}

import "./ProjectsIcon.vue?vue&type=style&index=0&id=3d97ebc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d97ebc2"]])

export default __exports__